import { IInsight, IProfile } from '@jumpstart/core';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../../core/firebase';
import InsightNotificationsService from '../insight-notifications-service';
import { InsightService } from '../insight-service';
import { formStyles } from '../styles';
import ContentField from './ContentField';

export interface IEventFormNew {
  copy: string | null;
  onError?(err: Error): void;

  onAdded?(id: string): void;
}

export default function EventFormNew(props: IEventFormNew) {
  const [user] = useAuthState(auth);
  const { onError, onAdded } = props;
  const [copy, setCopy] = useState<IInsight | null>(null);

  const handleError = (err: Error) => {
    console.error(err);
    if (onError) {
      onError(err);
    }
  }

  useEffect(() => {
    if (props.copy) {
      InsightService.get(props.copy)
        .then(setCopy);
    }
  }, [props.copy])

  return (
    <Formik
      initialValues={{ name: '' }}
      onSubmit={(values) => {
        const { name } = values;
        InsightService.createEvent(name)
          .then((id: string) => {
            // Copy contents over
            if (copy) {
              const {content, ...root} = {...copy, name, id}; // use copy but replace id and name
              Promise.all([InsightService.updateRoot(root), InsightService.updateContent({content, id})])
                .then(() => {
                  if (onAdded) {
                    onAdded(id);
                  }
                  return InsightNotificationsService.insight({...copy, name, id}, {firstName: user?.displayName} as any, 'created')
                })
                .catch(handleError)
            } else if (onAdded) {
              onAdded(id);
            }
          })
          .catch(handleError);
      }}
    >
      {
        ({ values, setFieldValue, handleChange, submitCount, errors, touched }) => (
          <Form>
            <Grid
              container
              direction="column"
              sx={{
                ...formStyles.section
              }}
              alignItems="center"
              justifyContent="center"
            >

            <ContentField
              id="name"
              name="name"
              value={values.name}
              onChange={handleChange}
              sx={formStyles.input}
              variant="outlined"
              label="Event Name"
              validation={{}}
              touched={true}
            />
            <Button variant="contained" type="submit" color="primary" style={{ maxWidth: 550 }}>Submit</Button>
            </Grid>
          </Form>
        )
      }
    </Formik>
  );
}
